(function() {
  if (!window.__isPreorder) return;

  const date = window.__preorderDate;

  function init() {
    // Button finden – Impulse-Theme spezifische Selektoren
    const btn = document.querySelector('.product-form__cart-submit')
      || document.querySelector('[name="add"]')
      || document.querySelector('.btn--add-to-cart');

    if (!btn) return;

    // Button-Text tauschen
    btn.textContent = 'Vorbestellen – Versand ab ' + date;

    // Hinweistext einfügen
    if (!document.querySelector('.preorder-hint')) {
      const hint = document.createElement('p');
      hint.className = 'preorder-hint';
      hint.style.cssText = 'font-size:13px;color:#666;margin-top:8px;';
      hint.textContent = '🕐 Vorbestellung: Versand voraussichtlich ab ' + date;
      btn.insertAdjacentElement('afterend', hint);
    }

    // Line Item Property anhängen
    const form = btn.closest('form');
    if (form) {
      form.addEventListener('submit', function() {
        let input = form.querySelector('input[name="properties[_Preorder_Info]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_Preorder_Info]';
          form.appendChild(input);
        }
        input.value = 'Voraussichtlicher Versand: ' + date;
      });
    }
  }

  // Warten bis DOM bereit ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();